// Función genérica para ordenar con customOrder
export const sortWithCustomOrder = <T extends { [key: string]: any }>(
  items: T[],
  valueKey: string,
  customOrder?: {
    getOrder: (value: any) => number
    orderMap?: Record<string | number, number>
  }
): T[] => {
  if (!items || items.length === 0) return []

  return [...items].sort((a, b) => {
    const valueA = a[valueKey]
    const valueB = b[valueKey]

    if (customOrder) {
      const orderA = customOrder.getOrder(valueA)
      const orderB = customOrder.getOrder(valueB)

      if (orderA !== orderB) {
        return orderA - orderB
      }
    }

    // Si no hay customOrder o son iguales, ordenar por el valor
    return valueA - valueB
  })
}
